import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Layout } from "../components/Layout";
import { api } from "../lib/api";
import { Store, MapPin } from "lucide-react";
import { cn } from "../lib/utils";

export default function CorporateRooftops() {
  const [rooftops, setRooftops] = useState([]);
  useEffect(() => { api.get("/rooftops").then((r) => setRooftops(r.data)); }, []);

  return (
    <Layout variant="corporate">
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">Corporate</div>
        <h1 className="text-3xl font-bold text-navy">Rooftops</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="rooftops-grid">
        {rooftops.map((r) => (
          <Link to={`/rooftop/${r.rooftop_id}`} key={r.rooftop_id}
                data-testid={`rooftop-card-${r.rooftop_id}`}
                className="bg-white border border-slate-200 rounded-xl p-5 hover:border-freddy-red hover:shadow-md transition-all group">
            <div className="flex items-start justify-between mb-4">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <Store size={14} className="text-freddy-red" />
                  <span className="text-[11px] uppercase tracking-wider font-bold text-freddy-red">{r.brand}</span>
                </div>
                <h3 className="text-lg font-bold text-navy leading-tight">{r.name.replace("Ourisman ", "")}</h3>
                <div className="flex items-center gap-1 text-xs text-slate-500 mt-0.5">
                  <MapPin size={10} /> {r.city}, {r.state}
                </div>
              </div>
              <div className="text-right">
                <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Inventory</div>
                <div className="text-2xl font-bold tabular text-navy">{r.inventory_units}</div>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-3 pt-3 border-t border-slate-100">
              <Metric label="Avg gross" value={`$${(r.avg_front_gross/1000).toFixed(1)}k`} />
              <Metric label="Turn" value={`${r.avg_days_to_sell}d`}
                color={r.avg_days_to_sell <= 35 ? "text-verdict-strongText" : r.avg_days_to_sell <= 50 ? "text-verdict-conditionalText" : "text-verdict-passText"} />
              <Metric label="Strong" value={r.strong_buys_open} color="text-freddy-red" />
            </div>
            <div className="mt-3 pt-3 border-t border-slate-100 text-[11px] text-slate-500">
              GM <span className="font-semibold text-navy">{r.gm_name}</span> · UCM <span className="font-semibold text-navy">{r.ucm_name}</span>
            </div>
          </Link>
        ))}
      </div>
    </Layout>
  );
}

function Metric({ label, value, color }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
      <div className={cn("text-base font-bold tabular", color || "text-navy")}>{value}</div>
    </div>
  );
}
